import posthog from "posthog-js";

if (import.meta.env.PROD && import.meta.env.VITE_DEPLOY_ENV === "production") {
  posthog.init("phc_umsYUwjFMcQ8RWSKsFEWoEt0VLb0BoXqCqUeBJCv2d2", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "always",
  });

  const employeeId = document.querySelector(
    "meta[name='current_employee_id']"
  )?.content;
  const userId = document.querySelector(
    "meta[name='current_user_id']"
  )?.content;

  if (employeeId) {
    posthog.identify(employeeId, {
      email: document.querySelector(
        "meta[name='current_employee_email']"
      )?.content,
      business_id: document.querySelector(
        "meta[name='current_business_id']"
      )?.content,
      business_name: document.querySelector(
        "meta[name='current_business_name']"
      )?.content,
      venue_id: document.querySelector(
        "meta[name='current_venue_id']"
      )?.content,
      venue_name: document.querySelector(
        "meta[name='current_venue_name']"
      )?.content,
    });
  } else if (userId) {
    posthog.identify(userId, {
      email: document.querySelector(
        "meta[name='current_user_email']"
      )?.content,
      business_id: document.querySelector(
        "meta[name='current_business_id']"
      )?.content,
      business_name: document.querySelector(
        "meta[name='current_business_name']"
      )?.content,
      venue_id: document.querySelector(
        "meta[name='current_venue_id']"
      )?.content,
      venue_name: document.querySelector(
        "meta[name='current_venue_name']"
      )?.content,
    });
  } else if (posthog.get_property("$user_id")) {
    posthog.reset();
  }

  const posthog_session_id = posthog.get_session_id();
  const csrfParam = document.querySelector("meta[name='csrf-param']")?.content;
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

  function __serialize(object) {
    const data = new FormData();
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        data.append(key, object[key]);
      }
    }
    return data;
  }

  navigator.sendBeacon(
    "/cal-hog/sessions",
    __serialize({
      [csrfParam]: csrfToken,
      posthog_session_id,
    })
  );
}
